import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { GenericModal } from './GenericModal';

export const SessionCancelModal = ({ show, handleClose, onSuccess, isProcessing = false }) => {
    const handleCancelClick = () => {
        try {
            onSuccess();
        } catch (error) {
            console.error('Failed to cancel session:', error);
        }
    };

    return (
        <GenericModal
            show={show}
            handleClose={isProcessing ? undefined : handleClose}
            title="Cancel Session"
            footerActions={
                <>
                    <Button 
                        variant="secondary" 
                        onClick={handleClose}
                        disabled={isProcessing}
                    >
                        Close
                    </Button>
                    <Button 
                        variant="danger" 
                        onClick={handleCancelClick}
                        disabled={isProcessing}
                    >
                        {isProcessing ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Cancelling...
                            </>
                        ) : (
                            'Cancel Session'
                        )}
                    </Button>
                </>
            }
        >
            <p>Are you sure you want to cancel this session?</p>
            <p className="text-danger">
                <strong>Warning:</strong> This action cannot be undone. The session will be permanently cancelled.
            </p>
        </GenericModal>
    );
};